import { sleep } from "./async";

let notificationFunctions = {};
let defaultFunction = "";

export function setNotificationFunction(func) {
    notificationFunctions = { ...notificationFunctions, ...func };
}

export function setDefaultFunction(func) {
    defaultFunction = func;
}

export async function notify(
    msg,
    functionName = defaultFunction,
    delay = 2000
) {
    const func = notificationFunctions[functionName];

    if (!func) return;

    if (Array.isArray(msg)) {
        if (msg.length <= 0) return;

        func({ mensagem: msg[0], mostrar: true });

        for (let i = 1; i < msg.length; i++) {
            await sleep(2000).then(() =>
                func({ mensagem: msg[i], mostrar: true })
            );
        }

        return;
    }

    func({ mensagem: msg, mostrar: true });
}
